/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */
require('./bootstrap');

// VUE
import { createApp, h } from 'vue';

// INERTIA
import { createInertiaApp } from "@inertiajs/vue3";
import { router } from '@inertiajs/vue3';

// ZIGGY
import { Ziggy } from './ziggy';

// PINIA
import { createPinia } from 'pinia';

// PRIMEVUE
import PrimeVue from 'primevue/config';
import Aura from '@primevue/themes/aura';
import ToastService from 'primevue/toastservice';
import Tooltip from "primevue/tooltip";
import { definePreset } from "@primevue/themes";

// VARIÁVEIS CSS
import '../sass/_variables.scss';

// LAYOUT
import MainLayout from "@/layouts/MainLayout.vue";

// VALIDADORES DE CAMPOS DE FORMULÁRIOS
import '@/validators/yupCpfCnpj';
import '@/validators/yupCpf';
import '@/validators/yupCnpj';
import '@/validators/yupCep';

// API
import { cancelAllRequests } from '@/api/requestManager';

// NAVEGAÇÃO
import { useNavegacaoStore } from "./stores/navegacao";

// THEME
import { ThemeService } from '@/theme/themeService';

router.on('start', () => {
    cancelAllRequests();
});

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

const MyPreset = definePreset(Aura, {
    semantic: {
        primary: {
            50:  '{blue.50}',
            100: '{blue.100}',
            200: '{blue.200}',
            300: '{blue.300}',
            400: '{blue.400}',
            500: '{blue.500}',
            600: '{blue.600}',
            700: '{blue.700}',
            800: '{blue.800}',
            900: '{blue.900}',
            950: '{blue.950}'
        }
    }
});

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

createInertiaApp({
    resolve: async (name) => {
        const page = await import(`./vue/page/${name}.vue`);

        const component = page.default;

        // Define layout padrão
        if (component.layout === undefined) {
            component.layout = MainLayout;
        }

        return component;
    },
    setup({ el, App, props, plugin }) {
        ThemeService.apply(props.initialPage.props.theme);

        const app = createApp({ render: () => h(App, props) });
        const pinia = createPinia();

        app.use(plugin);
        app.use(PrimeVue, {
            theme: {
                preset: MyPreset,
                options: {
                    darkModeSelector: '[data-bs-theme=dark]'
                }
            },
            locale: {
                monthNames: [
                    'Janeiro',
                    'Fevereiro',
                    'Março',
                    'Abril',
                    'Maio',
                    'Junho',
                    'Julho',
                    'Agosto',
                    'Setembro',
                    'Outubro',
                    'Novembro',
                    'Dezembro'
                ],
                monthNamesShort: [
                    'Jan',
                    'Fev',
                    'Mar',
                    'Abr',
                    'Mai',
                    'Jun',
                    'Jul',
                    'Ago',
                    'Set',
                    'Out',
                    'Nov',
                    'Dez'
                ],
                dayNamesMin: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sab'],
                clear: 'Limpar',
                today: 'Hoje',
                choose: ''
            }
        });
        app.use(pinia);
        app.use(Ziggy);

        const navegacaoStore = useNavegacaoStore();
        navegacaoStore.init();

        app.use(ToastService);
        app.directive('tooltip', Tooltip);

        app.mount(el);

        if (performance.getEntriesByType('navigation')[0]?.type === 'back_forward') {
            router.reload({ only: ['auth'] });
        }

        window.addEventListener('pageshow', (event) => {
            if (event.persisted) {
                router.reload({ only: ['auth'] });
            }
        });

        let eauthLogoutInProgress = false;

        const logoutLocalApplication = () => {
            if (eauthLogoutInProgress) return;

            eauthLogoutInProgress = true;
            localStorage.removeItem('eauth_token');
            window.location.href = route('logout');
        };

        window.addEventListener('eauth:logout', logoutLocalApplication);

        window.addEventListener('message', (event) => {
            if (event.data?.type === 'EAUTH_LOGOUT') {
                logoutLocalApplication();
            }
        });
    }
});
